import { render, staticRenderFns, recyclableRender, components } from "./audioPlay.vue?vue&type=template&id=375e29cc&scoped=true&"
var renderjs
import script from "./audioPlay.vue?vue&type=script&lang=js&"
export * from "./audioPlay.vue?vue&type=script&lang=js&"
import style0 from "./audioPlay.vue?vue&type=style&index=0&id=375e29cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375e29cc",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/audioPlay/audioPlay.vue"
export default component.exports